import { Link } from "react-router-dom";
import Marquee from "react-fast-marquee";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/motion-primitives";
import { useLang } from "@/i18n/LanguageContext";

// Primary CTA (solid orange, arrow)
export const CtaButton = ({ to, href, children, variant = "solid", className = "", ...props }) => {
  const base =
    "hover-arrow inline-flex items-center gap-2 text-sm font-bold uppercase tracking-wide px-8 py-4 transition-colors";
  const styles =
    variant === "solid"
      ? "bg-accentbrand text-white hover:bg-[#E63E00]"
      : variant === "dark"
      ? "bg-night text-white hover:bg-black"
      : "border border-ink text-ink hover:bg-night hover:text-white";
  const content = (
    <>
      {children} <ArrowUpRight size={16} />
    </>
  );
  if (href) {
    return (
      <a href={href} target="_blank" rel="noopener noreferrer" className={`${base} ${styles} ${className}`} {...props}>
        {content}
      </a>
    );
  }
  return (
    <Link to={to} className={`${base} ${styles} ${className}`} {...props}>
      {content}
    </Link>
  );
};

export const SectionLabel = ({ children, className = "" }) => (
  <span className={`inline-flex items-center gap-2 text-sm font-bold uppercase tracking-[0.15em] text-accentbrand ${className}`}>
    <span className="w-6 h-px bg-accentbrand" />
    {children}
  </span>
);

export const BrandMarquee = () => {
  const { lang } = useLang();
  const items = lang === "fr"
    ? ["GIHED COACHING", "PERSONAL TRAINER NICE", "PRÉPARATEUR PHYSIQUE", "COACHING EN LIGNE", "REMISE EN FORME"]
    : ["GIHED COACHING", "PERSONAL TRAINER NICE", "STRENGTH & CONDITIONING", "ONLINE COACHING", "GET IN SHAPE"];
  return (
    <div className="py-6 border-y border-border bg-secondary/60">
      <Marquee speed={40} gradient={false} autoFill>
        {items.map((t, i) => (
          <span key={i} className="mx-8 font-display font-black uppercase tracking-tight text-2xl lg:text-4xl text-ink flex items-center">
            {t}
            <span className="mx-8 text-accentbrand text-xl">✦</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
};

// A single feature/list item with a subtle top border
export const FeatureLine = ({ index, title, text }) => (
  <Reveal className="grid grid-cols-[auto_1fr] gap-6 py-7 border-t border-border" delay={index * 0.05}>
    <span className="font-mono-alt text-sm text-accentbrand pt-1">{String(index + 1).padStart(2, "0")}</span>
    <div>
      <h3 className="font-display text-xl lg:text-2xl font-semibold text-ink">{title}</h3>
      {text && <p className="mt-2 text-muted-foreground leading-relaxed">{text}</p>}
    </div>
  </Reveal>
);
